import { DatePipe, Time } from '@angular/common';
import { invalid } from '@angular/compiler/src/render3/view/util';
import { environment } from '@env/environment';

export class DateUtil {

  public static getInputDateValueFromDate(date: Date): string {
    const datePipe = new DatePipe(navigator.language);
    const dateFormat = 'y-MM-dd';

    if (date) {
      return datePipe.transform(date, dateFormat, 'UTC');
    } else {
      return '';
    }
  }

  public static getInputTimeValueFromDate(date: Date): string {
    const datePipe = new DatePipe(navigator.language);
    const timeFormat = 'HH:mm';

    if (date) {
      return datePipe.transform(date, timeFormat, 'UTC');
    } else {
      return '';
    }
  }

  public static getDateFromUTCDate(date: Date): Date {
    // if (date === null) return null;
    const utcDate: Date = new Date(Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds()));
    return utcDate;
  }

  public static getNowTime(): string {
    const date = new Date();
    return `${date.getUTCHours()}:${date.getUTCMinutes()}`;
  }

  // Captura una fecha UTC desde un string de un input con fecha y hora
  public static getDateFromUTCStringDateAndTime(dateString: string, timeString: string, isEnd: boolean = false): Date {
    if (!dateString || dateString === '') {return null; }
    return this.getDateFromUTCDate(this.getDateFromStringDateAndTime(dateString, timeString, isEnd));
  }
  // Captura una fecha UTC desde un string de un input con fecha y hora
  public static getDateFromStringDateAndTime(dateString: string, timeString: string, isEnd: boolean = false): Date {
    if (dateString) {
      if (!timeString || timeString === '') {
        return this.getDateFromStringDate(dateString, isEnd);
      } else {
        const datetimeStamp = new Date(`${dateString} ${timeString}${isEnd ? ':59' : ':00'}`);
        return datetimeStamp;
      }
    } else {
      return null;
    }
  }


  // Captura una fecha UTC desde un string de un input con fecha
  public static getDateFromUTCStringDate(dateString: string, isEndDay = false): Date {
    return this.getDateFromUTCDate(this.getDateFromStringDate(dateString, isEndDay));
  }
  // Captura una fecha desde un string de un input con fecha
  public static getDateFromStringDate(dateString: string, isEndDay = false): Date {
    if (dateString) {
      const datetimeStampAux = new Date(`${dateString} ${isEndDay ? '23:59:59' : '00:00:00'}`);
      return datetimeStampAux;
    } else {
      return null;
    }
  }

  public static getTimeStringFromInputTimeValue(timeString: string): string {
    if (timeString) {
      return timeString + ':00';
    } else {
      return null;
    }
  }

  // TODO deberá desaparecer
  public static getDateFromTimeString(timeString: string): Date {
    if (timeString) {
      const datetimeStampAux = new Date(`01/01/1900 ${timeString}`);
      return this.getDateFromUTCDate(datetimeStampAux);
    } else {
      return null;
    }
  }

  // TODO Deberá desaparecer
  public static getDateFromTime(time: Time): Date {
    if (time) {
      const datetimeStampAux = new Date(`01/01/1900 ${time.hours}:${time.minutes}`);
      return this.getDateFromUTCDate(datetimeStampAux);
    } else {
      return null;
    }
  }

  public static getDateTimeFormatFromDate(date: Date): string {
    const datePipe = new DatePipe(navigator.language);
    if (date) {
      return datePipe.transform(date, environment.dateFormat + ' ' + environment.timeFormat, 'UTC');
    } else {
      return '';
    }
  }

  public static getDateTimeFormatFromString(date: string): string {
    const datePipe = new DatePipe(navigator.language);
    if (date) {
      return datePipe.transform(date, environment.dateFormat + ' ' + environment.timeFormat, 'UTC');
    } else {
      return '';
    }
  }

  // Convierto un datetime sin timezone a un string datetime Z.
  public static getDateTimeFormatFromStringWithoutTimezone(dateString: string): string {
    if (dateString) {
      return this.getDateTimeFormatFromDate(new Date(dateString + 'Z'));
    } else {
      return '';
    }
  }

  public static getDateFormatFromDate(date: Date): string {
    const datePipe = new DatePipe(navigator.language);
    if (date) {
      return datePipe.transform(date, environment.dateFormat, 'UTC');
    } else {
      return '';
    }
  }
  public static getTimeFormatFromDate(date: Date): string {
    const datePipe = new DatePipe(navigator.language);
    if (date) {
      return datePipe.transform(date, environment.timeFormat);
    } else {
      return '';
    }
  }

  public static addMinutesFromTimeString(time: string, format: string, minutesAdd: number, onDay: boolean): string {
    const timeAux = this.getTimeFormatFromString(time, format);
    const hour = timeAux.substring(0, 2);
    const minutes = timeAux.substring(3, 5);
    const date = new Date();
    date.setHours(Number(hour), Number(minutes), 0);
    const newDate = new Date((date.getTime() + (minutesAdd * 60000)));
    let newHour = newDate.getHours() < 10 ? ('0' + newDate.getHours().toString()) : newDate.getHours().toString();
    let newMinutes = newDate.getMinutes() < 10 ? ('0' + newDate.getMinutes().toString()) : newDate.getMinutes().toString();
    if (onDay) {
      if (date.getDay() !== newDate.getDay()) {
        newHour = '23';
        newMinutes = '59';
      }
    }
    return newHour + ':' + newMinutes;
  }

  public static substractMinutesFromTimeString(time: string, format: string, minutesSubstract: number, onDay: boolean): string {
    const timeAux = this.getTimeFormatFromString(time, format);
    const hour = timeAux.substring(0, 2);
    const minutes = timeAux.substring(3, 5);
    const date = new Date();
    date.setHours(Number(hour), Number(minutes), 0);
    const newDate = new Date((date.getTime() - (minutesSubstract * 60000)));
    let newHour = newDate.getHours() < 10 ? ('0' + newDate.getHours().toString()) : newDate.getHours().toString();
    let newMinutes = newDate.getMinutes() < 10 ? ('0' + newDate.getMinutes().toString()) : newDate.getMinutes().toString();
    if (onDay) {
      if (date.getDay() !== newDate.getDay()) {
        newHour = '00';
        newMinutes = '00';
      }
    }
    return newHour + ':' + newMinutes;
  }

  public static getTimeFormatFromString(time: string, format: string): string {
    if (format === 'HH:mm') {
      return time.length > 5 ? time.substr(0, time.length - 3) : time;
    } else if (format === 'HH') {
      return time.length > 2 ? time.substr(0, time.length - 2) : time;
    } else {
      return time;
    }
  }

  public static isWithin(dateFrom1: Date, dateTo1: Date, dateFrom2: Date, dateTo2: Date): boolean {
    if (dateFrom1 < dateFrom2) {
      return false;
    } else if (dateTo1 == null && dateTo2 != null) {
      return false;
    } else if (dateTo1 != null && dateTo2 != null && dateTo1 > dateTo2) {
      return false;
    }
    return true;
  }

  public static isCompleteOut(dateFrom1: Date, dateTo1: Date, dateFrom2: Date, dateTo2: Date): boolean {
    if (dateTo1 && dateTo1 < dateFrom2) {
      return true;
    }
    if (dateTo2 && dateTo2 < dateFrom1) {
      return true;
    }
    return false;
  }

  public static isEquals(date1: Date, date2: Date): boolean {
    // hora de llegada
    if (date1 !== null && date2 !== null) {
      // si las hora de la llegada son distinto de nulo comparo las horas
      if (!(date1 instanceof Date)) {
        date1 = new Date(date1);
      }
      if (!(date2 instanceof Date)) {
        date2 = new Date(date2);
      }
      if (date1.getTime() !== date2.getTime()) {
        // si las horas son distintas marco la hora como hetereogeneo
        return false;
      }
    } else if ((date1 !== null && date2 === null) ||
               (date1 === null && date2 != null)) {
        // alguna de las horas es a nul y la otra no, se marca como heterogenea
        return false;
    }
    return true;
  }

  public static getUtcFtomDate(date: Date): Date {
    const dateUtc =  Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(),
    date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
    return new Date(dateUtc);
  }

	public static nextStringDateOfSSIMOperationDaysAfter(dateString: string, ssimOperationDays: string): string {
    let date: Date = new Date(dateString);
    date = this.nextDateOfSSIMOperationDaysAfter(date, ssimOperationDays);
    const datePipe = new DatePipe(navigator.language);
    return datePipe.transform(date, 'yyyy-MM-dd');
  }

	public static previousStringDateOfSSIMOperationDaysAfter(dateString: string, ssimOperationDays: string): string {
    let date: Date = new Date(dateString);
    date = this.previousDateOfSSIMOperationDaysAfter(date, ssimOperationDays);
    const datePipe = new DatePipe(navigator.language);
    return datePipe.transform(date, 'yyyy-MM-dd');
  }


	public static nextDateOfSSIMOperationDaysAfter(date: Date, ssimOperationDays: string): Date {

		let dayFound = false;
    let dateToMove =  new Date(date);
		while (!dayFound) {
      const dateToMoveUTC: Date =  DateUtil.getUtcFtomDate(dateToMove);
      let dayOfWeek = dateToMoveUTC.getUTCDay();
      if (dayOfWeek === 0) {
        dayOfWeek = 7;
      }
      const foundIndex = ssimOperationDays.indexOf(dayOfWeek.toString());
			// const foundIndes = Character.forDigit((date.getDayOfWeek().ordinal() + 1 == 8) ? 1 : date.getDayOfWeek().ordinal() + 1, 10);
      if (foundIndex !== -1) {
				dayFound = true;
			} else {
				dateToMove = new Date(dateToMove.getTime() + (1000*60*60*24));
			}
		}
		return dateToMove;
	}

	public static previousDateOfSSIMOperationDaysAfter(date: Date, ssimOperationDays: string): Date {
		let dayFound = false;
    let dateToMove =  new Date(date);
		while (!dayFound) {
      const dateToMoveUTC: Date =  DateUtil.getUtcFtomDate(dateToMove);
      let dayOfWeek = dateToMoveUTC.getUTCDay();
      if (dayOfWeek === 0) {
        dayOfWeek = 7;
      }
      const foundIndex = ssimOperationDays.indexOf(dayOfWeek.toString());
			// const foundIndes = Character.forDigit((date.getDayOfWeek().ordinal() + 1 == 8) ? 1 : date.getDayOfWeek().ordinal() + 1, 10);
      if (foundIndex !== -1) {
				dayFound = true;
			} else {
				dateToMove = new Date(dateToMove.getTime() - (1000*60*60*24));
			}
		}
		return dateToMove;
	}

  public static getAllMillisecondsFromInitForTime(time: string): number {
    if (time) {
      return new Date('1970-01-01T' + DateUtil.getTimeFormatFromString(time, 'HH:mm:ss') + '.000+0000').getTime();
    }
    return 0;
  }

  public static getCronossTimeFormatFromTimeString(time: string): string {
    if (!time) {return null; }
    const timstr = time;
    return timstr.substring(0, 5);
  }

  public static getCronossTimeFormatFromDateTimeString(dateTime: string): string {
    if (!dateTime) {return null; }
    const time = dateTime.substring(11, 16);
    return time;
  }


}
